// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { MonolithImageSizeFragmentDoc } from '../monolithImageSize.fragment.generated';
export const ReviewsFragmentDoc = `
    fragment reviews on Review {
  id
  name
  comment
  date
  picture {
    id
    url
    sizes(names: [W250, W320, W480, W640]) {
      ...monolithImageSize
    }
  }
  rating
}
    `;